module.exports = __webpack_public_path__ + "static/media/Logo.1653c647.svg";